<style scoped>
    .Menu-picker-wrap {
        position: absolute;
        left: 315px;
    }
    ul {
        font-size: 18px;
        width: 204px;
    }
    li {
        height: 43px;
        line-height: 43px;
        text-align: center;
        cursor: pointer;
    }
    .default {
        color: #fff;
        background-color: #0C1844;
    }
    .default:hover {
        color: #6BFFFD;
    }
    .operate {
        color: #666666;
        background-color: #fff;
    }
    .operate:hover {
        color: #fff;
        background-color: #3673FF;
    }
</style>

<template>
    <div class="Menu-picker-wrap" v-if="menuShow">
        <ul>
            <li v-for="(item, index) in slots" :key="index" :class="{'default': true, 'operate': operateStyle}"
            @click="menuPickerClicked(item, index)">{{ item }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'menu_picker',
        props: {
            slots: {
                type: Array,
                required: true
            },
            operateStyle: {
                type: Boolean,
                default: false
            },
            menuShow: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            menuPickerClicked(item, index) {
                this.$emit('change', item, index)
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/page/common/MenuPicker.vue